import httpClient from '@/http-client'

export const formViewModel = (options = {}) => {
  return httpClient
    .get('/api/year-books/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  formViewModel
}
